import PagerTemplate from '../../html/components/pager.html'
import PagerToolbarTemplate from '../../html/components/pager-toolbar.html'

import Component from '../shared/component'
import Relation, {MemberOf, HasOne, HasMany} from '../shared/mixins/relation'

const pagerItems = Relation()
const pagerToolbars = Relation()

export const Pager = Component('v-pager', {
  mixins: [
    HasOne(pagerItems, 'items'),
    HasMany(pagerToolbars, 'toolbars')
  ],
  template: PagerTemplate,
  props: {
    page: {
      description: `
        The currently active page.
      `,
      type: [Number, String],
      default: 0
    },
    total: {
      description: `
        The total number of items. Has no effect if <code>&lt;v-pager-items></code> is used for paging virtual nodes.
      `,
      type: [Number, String],
      default: 0
    },
    perPage: {
      description: `
        The number of items to show per page.
      `,
      type: [Number, String],
      default: 10
    }
  },
  data () {
    return {
      active: parseInt(this.page)
    }
  },
  computed: {
    length () {
      return this.items ? this.items.length : this.total
    },

    pages () {
      return Math.ceil(this.length / parseInt(this.perPage))
    },

    first () {
      return parseInt(this.perPage) * this.active
    },

    last () {
      return parseInt(this.perPage) + this.first
    }
  },
  methods: {
    navigate (page) {
      this.active = Math.max(0, Math.min(this.pages - 1, parseInt(page)))
    }
  },
  watch: {
    page () {
      this.active = parseInt(this.page)
    },

    active () {
      this.$emit('change', this.active)
    },

    length () {
      this.navigate(this.active)
    }
  }
})

export const PagerItems = Component('v-pager-items', {
  mixins: [
    MemberOf(pagerItems, 'pager')
  ],
  data () {
    return {
      length: 0
    }
  },
  render (createElement) {
    const {pager} = this
    const children = this.$slots.default || []
    const slice = pager ? children.slice(pager.first, pager.last) : children

    this.length = children.length

    return createElement(
      'div',
      {
        class: 'pager-items',
        attrs: {
          id: this.id
        }
      },
      slice
    )
  }
})

export const PagerToolbar = Component('v-pager-toolbar', {
  mixins: [
    MemberOf(pagerToolbars, 'pager')
  ],
  template: PagerToolbarTemplate,
  props: {
    fill: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    labelFirst: {
      type: String,
      required: true
    },
    labelLast: {
      type: String,
      required: true
    },
    labelNext: {
      type: String,
      required: true
    },
    labelPrev: {
      type: String,
      required: true
    },
    labelOf: {
      type: Function,
      default (pages) {
        return `of ${pages}`
      }
    }
  },
  computed: {
    pages () {
      const {pager} = this

      if (pager) {
        return pager.pages
      }
    },

    active () {
      const {pager} = this

      if (pager) {
        return pager.active
      }
    },

    items () {
      const {pager} = this

      if (!pager) {
        return
      }

      const {items} = pager

      if (items) {
        return items.id
      }
    }
  },
  methods: {
    next () {
      const {pager} = this

      if (pager) {
        pager.navigate(pager.active + 1)
      }
    },

    prev () {
      const {pager} = this

      if (pager) {
        pager.navigate(pager.active - 1)
      }
    },

    first () {
      const {pager} = this

      if (pager) {
        pager.navigate(0)
      }
    },

    last () {
      const {pager} = this

      if (pager) {
        pager.navigate(pager.length - 1)
      }
    },

    input (page) {
      const {pager} = this

      if (pager) {
        pager.navigate(page - 1)
      }
    }
  }
})
